// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ApplicationAndManagement--next-sr-only--3roFfxS","applicationAndManagement":"ApplicationAndManagement--applicationAndManagement--31ToGG9"};